module.exports = __webpack_public_path__ + "img/knowledge.88ad72a0.png";